import VueFormulate from '@braid/vue-formulate'

export default VueFormulate